<img [src]="'/assets/images/spice-of-europe-logo.svg' | ssrEmptyString" alt="Budapest - Spice of europe" width="120" height="60" />
